/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Frame_RateInputs */

const en_frame_rate = /** @type {(inputs: Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frame Rate`)
};

const fr_frame_rate = /** @type {(inputs: Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fréquence d’images`)
};

const de_frame_rate = /** @type {(inputs: Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildrate`)
};

const it_frame_rate = /** @type {(inputs: Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequenza dei fotogrammi`)
};

const ru_frame_rate = /** @type {(inputs: Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Частота кадров`)
};

const es_frame_rate = /** @type {(inputs: Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidad de fotogramas`)
};

const zh_cn2_frame_rate = /** @type {(inputs: Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`帧率`)
};

const ja_frame_rate = /** @type {(inputs: Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フレームレート`)
};

const hi_frame_rate = /** @type {(inputs: Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ्रेम रेट`)
};

const pt_pt2_frame_rate = /** @type {(inputs: Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taxa de quadros`)
};

/**
* | output |
* | --- |
* | "Frame Rate" |
*
* @param {Frame_RateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const frame_rate = /** @type {((inputs?: Frame_RateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Frame_RateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_frame_rate(inputs)
	if (locale === "de") return de_frame_rate(inputs)
	if (locale === "it") return it_frame_rate(inputs)
	if (locale === "ru") return ru_frame_rate(inputs)
	if (locale === "es") return es_frame_rate(inputs)
	if (locale === "zh-CN") return zh_cn2_frame_rate(inputs)
	if (locale === "ja") return ja_frame_rate(inputs)
	if (locale === "hi") return hi_frame_rate(inputs)
	if (locale === "pt-PT") return pt_pt2_frame_rate(inputs)
	return en_frame_rate(inputs)
});